<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('ADM_DEPARTMENT_ADD')">New</a-button>
      </div>
      <a-table
        :columns="columns"
        :dataSource="datas"
        :rowKey="(record) => record.id"
      >
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="handleEdit(record)" :disabled="!$auth('ADM_DEPARTMENT_EDIT')">Edit</a>
            <a-divider type="vertical" />
            <a-popconfirm title="Are you sure delete?" @confirm="onDeleteConfirmed(record)" okText="Yes" cancelText="No">
              <a href="javascript:;" :disabled="!$auth('ADM_DEPARTMENT_DELETE')">Delete</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>
    </a-spin>
  </a-card>
</template>

<script>
import DepartmentApi from '@/api/adm/api-department'

function deleteEmptyChildren (node) {
  if (node) {
    const childs = node.children
    if (childs && childs.length > 0) {
      childs.forEach(c => {
        deleteEmptyChildren(c)
      })
    } else {
      delete node.children
    }
  }
}

export default {
  name: 'DepartmentList',
  components: {
  },
  data () {
    return {
      // 部门树列表
      datas: [],
      loading: true,
      // 表头
      columns: [
        {
          title: 'Dept Name',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      const depts = await this.loadAllTree()
      if (depts && depts.length > 0) {
        depts.forEach(d => {
          deleteEmptyChildren(d)
        })
      }
      this.datas = depts
      this.loading = false
    },
    // 读取部门树
    loadAllTree () {
      return new Promise((resolve, reject) => {
        DepartmentApi.findAllTree()
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      DepartmentApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('User delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    refreshCurrentPage () {
      this.initData()
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
